// ProductModalStyles.js
import styled from "styled-components";
import OrnamentImg from "../../assets/images/ornament.png";

const colors = {
  text: "#1a1a1a",
  white: "#ffffff",
  gold: "#8b8064",
  line: "rgba(0,0,0,0.08)",
  overlay: "rgba(0,0,0,0.55)",
};

export const Overlay = styled.div`
  z-index: 1400; /* ⬅️ peste FlipBook */
  position: fixed;
  inset: 0;
  background: ${colors.overlay};
  backdrop-filter: blur(2px);

  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 100dvh;
  padding: 12px;
`;

export const Modal = styled.div`
  width: 100%;
  max-width: 860px;
  color: ${colors.text};
  max-height: 92vh;
  background: transparent;
  transform: translateY(-2vh);

  @media (max-width: 768px) {
    max-width: 100%;
    transform: none;
  }
`;

export const Frame = styled.div`
  position: relative;
  background: ${colors.white};
  border-radius: 20px;
  padding: 8px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.32);
  overflow: hidden;

  &::after {
    /* chenar discret interior, ca la ReservationModal */
    content: "";
    position: absolute;
    inset: 8px;
    border-radius: 14px;
    pointer-events: none;
    border: 1px dashed rgba(0, 0, 0, 0.14);
  }
`;

export const Header = styled.div`
  position: relative;
  padding: 28px 42px 10px;
  text-align: center;

  @media (max-width: 480px) {
    padding: 22px 18px 6px;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 28px;
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: 0.2px;
  color: #172033;
  font-family: "Georgia", "Times New Roman", Times, serif;

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const HeaderOrnament = styled.div`
  width: 180px;
  height: 22px;
  margin: 8px auto 0;
  background: url(${OrnamentImg}) center/contain no-repeat;
  opacity: 0.95;
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  appearance: none;
  border: 0;
  background: ${colors.white};
  width: 34px;
  height: 34px;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12), inset 0 0 0 1px ${colors.line};
  cursor: pointer;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 14px;
    height: 2px;
    background: ${colors.gold};
    transform-origin: center;
  }
  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  &:hover {
    filter: brightness(0.98);
  }
`;

/* ——— Layout conținut ——— */
export const Top = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.25fr;
  gap: 20px;
  padding: 0 24px 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 16px 18px;
  }
`;

export const ImgWrap = styled.figure`
  margin: 0;
  border-radius: 16px;
  overflow: hidden;
  background: #f8f8f8;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
  aspect-ratio: 4/3;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const Meta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Price = styled.div`
  align-self: flex-end;
  font-weight: 800;
  font-size: 20px;
  color: ${colors.gold};

  @media (max-width: 720px) {
    align-self: flex-start;
  }
`;

export const Tabs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TabBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  button {
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: ${colors.white};
    padding: 8px 14px;
    border-radius: 10px;
    cursor: pointer;
    font-weight: 700;
    color: ${colors.text};
    transition: all 0.2s ease;

    &[data-active="true"] {
      border-color: ${colors.gold};
      color: ${colors.gold};
      background: #fff7e6;
      box-shadow: 0 0 0 2px rgba(139, 128, 100, 0.15) inset;
    }

    &:hover {
      border-color: ${colors.gold};
    }
  }
`;

export const Panel = styled.div`
  background: ${colors.white};
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 15px;
  line-height: 1.6;
  color: ${colors.text};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;
